module.exports = __webpack_public_path__ + "static/img/Landing Page_Banner sin botón_Mi Colegio@4x.e2ed7618.png";